import React from "react";
import HOMEBAN from "../images/videos/RAD1.mp4";
import "./ServiceBanner.css"; // make sure CSS is imported

export default function ServiceBanner() {
  return (
    <section className="hero">
      {/* VIDEO */}
      <video
        className="hero-video"
        src={HOMEBAN}
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="hero-content" style={{ display: 'none' }}>
        <h1>Our Professional Services</h1>
      </div>

    </section>
  );
}
